import axios from 'axios';

export const getVolumes = async (apiUrl, region, queryParams) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  if (queryParams) {
    return axios.get(`${apiUrl}/volumes/detail${queryParams}`, settings);
  } else {
    return axios.get(`${apiUrl}/volumes/detail`, settings);
  }
}

export const createVolume = async (apiUrl, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.post(`${apiUrl}/volumes`, data, settings);
}

export const deleteVolume = async (apiUrl, volume_id, region, cascade) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  if (cascade) {
    return axios.delete(`${apiUrl}/volumes/${volume_id}?force=true&cascade=true`, settings);
  } else {
    return axios.delete(`${apiUrl}/volumes/${volume_id}?force=true`, settings);
  }
}

export const getVolumeDetails = async (apiUrl, volume_id, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.get(`${apiUrl}/volumes/${volume_id}`, settings);
}

export const updateVolume = async (apiUrl, volume_id, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.put(`${apiUrl}/volumes/${volume_id}`, data, settings);
}

// TRANSFERS
export const getTransfers = async (apiUrl) => {
  let osToken = localStorage.getItem('current_project_token');
  const settings = {
    headers: {
      'X-Auth-Token': osToken,
    }
  };

  return axios.get(`${apiUrl}/os-volume-transfer`, settings);
}

export const createTransfers = async (apiUrl, data) => {
  let osToken = localStorage.getItem('current_project_token');
  const settings = {
    headers: {
      'X-Auth-Token': osToken,
    }
  };

  return axios.post(`${apiUrl}/os-volume-transfer`, data, settings);
}

export const cancelTransfer = async (apiUrl, data) => {
  let osToken = localStorage.getItem('current_project_token');
  const settings = {
    headers: {
      'X-Auth-Token': osToken,
    }
  };

  return axios.delete(`${apiUrl}/os-volume-transfer/${data}`, settings);
}

export const acceptTransfer = async (apiUrl, transferId, data) => {
  let osToken = localStorage.getItem('current_project_token');
  const settings = {
    headers: {
      'X-Auth-Token': osToken,
    }
  };

  return axios.post(`${apiUrl}/os-volume-transfer/${transferId}/accept`, data, settings);
}

// VOLUME SNAPSHOT
export const createVolumeSnapShot = async (apiUrl, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.post(`${apiUrl}/snapshots`, data, settings);
}

export const deleteVolumeSnapshot = async (apiUrl, snapshotId, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.delete(`${apiUrl}/snapshots/${snapshotId}`, settings);
}


// ACTIONS
export const volumeAction = async (apiUrl, volumeID, data, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
      'OpenStack-API-Version': 'volume 3.68',
    }
  };

  return axios.post(`${apiUrl}/volumes/${volumeID}/action`, data, settings);
}

export const getVolumeQuota = async (apiUrl, region) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  let projectId = JSON.parse(localStorage.getItem('current_project'))[region];

  if (projectId == undefined) {
      if (region === 'core') {
          projectId = JSON.parse(localStorage.getItem('current_project')).ams2;
      } else if (region === 'stagingamstwo') {
          projectId = JSON.parse(localStorage.getItem('current_project')).staging102;
      } else if (region === 'stagingamsthree') {
          projectId = JSON.parse(localStorage.getItem('current_project')).staging101;
      }
  }
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  return axios.get(`${apiUrl}/os-quota-sets/${projectId}?usage=True`, settings);
}

export const getVolumeTypes = async (apiUrl, region, queryParams) => {
  let tokens = JSON.parse(localStorage.getItem('region_tokens'));
  let regionTokenData = tokens.find(item => item.name === region);
  const settings = {
    headers: {
      'X-Auth-Token': regionTokenData.token,
    }
  };

  if (queryParams) {
    return axios.get(`${apiUrl}/types${queryParams}`, settings);
  } else {
    return axios.get(`${apiUrl}/types`, settings);
  }
}
